<template>
  <div class="form-date" :class="[{ preview: preview }, ...wrapperClasses]">
    <div class="title flex mb-2">
      {{ title }}<span v-if="mandatory" class="required ml-2">*</span>
      <div
        v-if="!preview"
        @click="onClickHelp"
        class="flex cursor-pointer ml-2"
      >
        <feather-icon
          :icon="'HelpCircleIcon'"
          class="inline-flex rounded-full"
          svgClasses="h-5"
        ></feather-icon>
      </div>
    </div>
    <div v-if="showPlainText" class="flex">
      <div class="editable-input-area" @click="isEdit = true">
        <span class="editable-input-text">{{
          inputValue ? displayInputValue : "-"
        }}</span>
      </div>
      <common-updated-label
        :updatedAt="updateDateLabel"
        :createdAt="createDateLabel"
      />
      <div class="mandatory-switch flex" v-if="showMandatorySwitch">
        <vs-switch color="#2D9CDB" class="ml-6" v-model="mandatoryValue" />
        <span class="ml-2">必須</span>
      </div>
      <template v-if="showStatus">
        <status-chip
          v-if="isStatusFixed"
          class="ml-3 mr-2"
          :label="status.label"
          :color="status.color"
        ></status-chip>
        <status-dropdown-select
          v-else
          class="ml-3 mr-2"
          :options="filteredStatusOptions"
          :value.sync="status"
          :onClickOption="onStatusChange"
          clickEvent
        ></status-dropdown-select>
      </template>
    </div>
    <div v-else class="flex row-gap-8 col-gap-8 w-full">
      <flat-pickr
        class="claim-report-type-date-form-calendar start-date"
        v-model="editInputValue"
        :config.sync="configTimePicker"
        ref="selectedDatePicker"
      />
      <div class="btn-area flex gap-3" v-if="!preview">
        <common-button
          class="save-btn-template"
          title="保存"
          type="filled"
          :click="
            () => {
              onClickSaveButton();
            }
          "
          :btnStyle="{
            paddingLeft: 0,
            paddingRight: 0,
            width: '70px',
            height: '40px',
          }"
          :disabled="preview"
        ></common-button>
        <common-button
          class="cancel-btn-template"
          type="border"
          color="#BDBDBD"
          :click="
            () => {
              cancelEdit();
            }
          "
          :btnStyle="{
            paddingLeft: 0,
            paddingRight: 0,
            width: '70px',
            height: '40px',
            fontSize: '12px',
          }"
          text-color="#757575"
          title="キャンセル"
          :disabled="preview"
        ></common-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import CommonButton from "../molecules/CommonButton.vue";
import { toYMDHm_jp } from "@/utils/entity/DateUtil";
import flatPickr from "vue-flatpickr-component";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import CommonUpdatedLabel from "../molecules/CommonUpdatedLabel.vue";
import StatusDropdownSelect from "../organisms/StatusDropdownSelect.vue";
import StatusChip from "../molecules/StatusChip.vue";
const FLAT_PICKR_CLASS_NAME = "flatpickr-calendar";
const CLAIM_REPORT_FLAT_PICKR_CLASS_NAME =
  "claim-report-type-date-form-calendar";
const STYLE_OVERWRITE = "style-overwrite";
export default {
  components: {
    CommonButton,
    flatPickr,
    CommonUpdatedLabel,
    StatusDropdownSelect,
    StatusChip,
  },
  mixins: [ColorMixin],
  name: "O.ClaimTypeTextSmall",
  props: {
    wrapperClasses: {
      type: Array, // Array<String>
      default() {
        return [];
      },
    },
    preview: {
      type: Boolean,
      default: false,
    },
    onClickSave: {
      type: Function,
      default: () => {},
    },
    onSwitchChange: {
      type: Function,
      default: () => {},
    },
    onClickHelp: {
      type: Function,
      default: () => {},
    },
    onStatusChange: {
      type: Function,
      default: () => {},
    },
    title: {
      type: String,
    },
    inputValue: {
      type: String,
    },
    mandatory: {
      type: Boolean,
    },
    isAdmin: {
      type: Boolean,
    },
    createDate: {
      type: Number,
    },
    updateDate: {
      type: Number,
    },
    initialSwitchValue: {
      type: Boolean,
      default: false,
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    initialStatusValue: {
      type: Object,
    },
  },
  data() {
    return {
      isEdit: false,
      mandatoryValue: this.initialSwitchValue,
      editInputValue: null,
      configTimePicker: {
        enableTime: false,
        dateFormat: "Y/m/d",

        minDate: null,
        maxDate: null,
        locale: Japanese,
        monthSelectorType: "static",
      },
      status: null,
    };
  },
  watch: {
    mandatoryValue(value) {
      this.onSwitchChange(value);
    },
  },
  created() {
    this.mandatoryValue = this.initialSwitchValue;
    this.initializeEditInput();
  },
  computed: {
    displayInputValue() {
      if (this.inputValue) {
        return `${this.inputValue}`;
      } else {
        return "-";
      }
    },
    createDateLabel() {
      return toYMDHm_jp(this.createDate);
    },
    updateDateLabel() {
      return toYMDHm_jp(this.updateDate);
    },
    showPlainText() {
      if (!this.preview && !this.isEdit) {
        return true;
      } else {
        return false;
      }
    },
    showMandatorySwitch() {
      if (this.isAdmin && this.showPlainText) {
        return true;
      } else {
        return false;
      }
    },
    filteredStatusOptions() {
      return this.statusOptions.filter(element => element.value != 1);
    },
    isStatusFixed() {
      return this.status.value == 1 || !this.isAdmin;
    },
    showStatus() {
      return !this.preview && this.mandatory;
    },
  },

  methods: {
    initializeEditInput() {
      this.editInputValue = this.inputValue ? this.inputValue : null;
      this.status = this.initialStatusValue;
    },
    cancelEdit() {
      this.isEdit = false;
      this.initializeEditInput();
    },
    onClickSaveButton() {
      this.isEdit = false;
      this.onClickSave(this.editInputValue);
    },
  },
  mounted() {
    // flatpickrに独自スタイルを当てるためにclass付与
    document.querySelectorAll(`.${FLAT_PICKR_CLASS_NAME}`).forEach(fc => {
      fc.classList.add(CLAIM_REPORT_FLAT_PICKR_CLASS_NAME, STYLE_OVERWRITE);
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";
.form-date {
  min-height: 80px;
  width: 100%;
  &.preview {
    pointer-events: none;
  }
  .required {
    font-weight: bold;
    color: $aisea-red;
  }
  .update-date-label {
    font-size: 12px;
  }
  .editable-input-area {
    margin-right: 18px;
    transition: background-color 0.3s;
    flex: 1;
    cursor: pointer;
    .editable-input-text {
      line-height: 2.2;
    }
    &:hover {
      background: $hover-background-blue;
    }
  }
  .flatpickr-input.active {
    border: 1px solid $aisea-blue !important;
  }
}
.flatpickr-calendar {
  &.claim-report-type-date-form-calendar {
    .flatpickr-current-month {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: baseline;
      gap: 30px;

      span.cur-month {
        color: #626262;
      }
    }
    .flatpickr-day {
      &.selected,
      &.startRange,
      &.endRange,
      &.selected.inRange,
      &.startRange.inRange,
      &.endRange.inRange,
      &.selected:focus,
      &.startRange:focus,
      &.endRange:focus,
      &.selected:hover,
      &.startRange:hover,
      &.endRange:hover,
      &.selected.prevMonthDay,
      &.startRange.prevMonthDay,
      &.endRange.prevMonthDay,
      &.selected.nextMonthDay,
      &.startRange.nextMonthDay,
      &.endRange.nextMonthDay {
        background: $aisea-blue !important;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: $aisea-blue !important;
      }
    }
  }
}
</style>
